import Cookies from 'js-cookie';

const RCA_USER_COOKIE_NAME = 'lmdstok';
const RCA_UID_COOKIE_NAME = 'rcauid';
const RCA_COUNTRY_COOKIE_NAME = 'Country';

const getDomain = (hostname: string): string => {
  if (hostname === 'localhost') {
    return hostname;
  } else if (hostname.includes('.realestate.com.au')) {
    return '.realestate.com.au';
  }
  return '.realcommercial.com.au';
};

export const getUserInfoFromCookies = (): {
  token: string | undefined;
  rcauid: string | undefined;
  countryCode: string | undefined;
} => ({
  token: Cookies.get(RCA_USER_COOKIE_NAME),
  rcauid: Cookies.get(RCA_UID_COOKIE_NAME),
  countryCode: Cookies.get(RCA_COUNTRY_COOKIE_NAME),
});

export const removeToken = (): void =>
  Cookies.remove(RCA_USER_COOKIE_NAME, {
    path: '/',
    expires: Date.parse('Thu, 01 Jan 1970 00:00:01 GMT'),
    domain: getDomain(window.location.hostname),
  });
